import React from 'react';
import PageHero from '../components/PageHero';
import BoxContentOne from '../Content/boxcontentone';
import SliderNewsOne from './Slider news one';
import SliderNewsTwo from './Slider news two';
import SliderNewsThree from './Slider news three';
import NewsArticle from './MoneyPage';
import './News.css';

const News = () => (
  <main className="news-page">
    <div className="news-page__container">
      <PageHero variant="centered" />
      <BoxContentOne />

      <header className="news-page__header">
        <h1>Vientiane Traffic News</h1>
      </header>

      <SliderNewsThree />
      <SliderNewsOne />
      <SliderNewsTwo />
      <NewsArticle />
    </div>
  </main>
);

export default News;
